import React, { useEffect, useRef } from 'react';

const ConfettiEffect = () => {
  const canvasRef = useRef(null);
  
  useEffect(() => {
    const canvas = canvasRef.current;
    const ctx = canvas.getContext('2d');
    canvas.width = window.innerWidth;
    canvas.height = window.innerHeight;
    
    // Confetti particles
    const particles = [];
    const particleCount = 150;
    const colors = [
      '#FBBF24', // yellow-400
      '#F59E0B', // amber-500
      '#10B981', // emerald-500
      '#3B82F6', // blue-500
      '#8B5CF6', // violet-500
      '#EC4899', // pink-500
      '#EF4444', // red-500
      '#FFFFFF', // white
    ];
    
    // Create particles
    for (let i = 0; i < particleCount; i++) {
      particles.push({
        x: Math.random() * canvas.width,
        y: Math.random() * canvas.height - canvas.height,
        size: Math.random() * 10 + 5,
        color: colors[Math.floor(Math.random() * colors.length)],
        rotation: Math.random() * 360,
        speed: Math.random() * 3 + 2,
        velocity: Math.random() * 2 - 1,
        rotationSpeed: Math.random() * 0.2 - 0.1,
        shape: Math.random() > 0.5 ? 'circle' : 'rect'});
    }
    
    // Animation loop
    const animate = () => {
      ctx.clearRect(0, 0, canvas.width, canvas.height);
      
      // Update and draw particles
      for (let i = 0; i < particles.length; i++) {
        const p = particles[i];
        
        // Update position
        p.y += p.speed;
        p.x += p.velocity;
        p.rotation += p.rotationSpeed;
        
        // Draw particle
        ctx.save();
        ctx.beginPath();
        ctx.translate(p.x, p.y);
        ctx.rotate(p.rotation * Math.PI / 180);
        
        if (p.shape === 'circle') {
          ctx.arc(0, 0, p.size / 2, 0, Math.PI * 2, false);
          ctx.fillStyle = p.color;
          ctx.fill();
        } else {
          ctx.rect(-p.size / 2, -p.size / 2, p.size, p.size);
          ctx.fillStyle = p.color;
          ctx.fill();
        }
        
        ctx.restore();
        
        // Reset particle if it goes off screen
        if (p.y > canvas.height) {
          particles[i] = {
            x: Math.random() * canvas.width,
            y: -20,
            size: Math.random() * 10 + 5,
            color: colors[Math.floor(Math.random() * colors.length)],
            rotation: Math.random() * 360,
            speed: Math.random() * 3 + 2,
            velocity: Math.random() * 2 - 1,
            rotationSpeed: Math.random() * 0.2 - 0.1,
            shape: Math.random() > 0.5 ? 'circle' : 'rect'
          };
        }
      }
      
      requestAnimationFrame(animate);
    };
    
    const animationId = requestAnimationFrame(animate);
    
    // Clean up
    return () => {
      cancelAnimationFrame(animationId);
    };
  }, []);
  
  return (
    <canvas
      ref={canvasRef}
      className="fixed inset-0 pointer-events-none z-50"
      style={{ width: '100%', height: '100%' }}
    />
  );
};

export default ConfettiEffect;
